<template>
    <el-input
        v-if="mode == 'edit'"
        :ref="reference"
        v-model="currentValue"
        :placeholder="prop.defaultValue"
    >
    </el-input>
    <a v-else target="_blank" :href="urlFormatted"> {{ currentValue }} </a>
</template>

<script>
import CfMixin from '../../../mixins/CustomfieldInputsMixins';
import { deepEqual } from 'Helpers/deepEqual';

export default {
    mixins: [CfMixin],
    emits: ['update:modelValue'],
    data() {
        return {
            localValue: this.value,
            currentValue: '',
        };
    },
    computed: {
        urlFormatted() {
            if (!/^(f|ht)tps?:\/\//i.test(this.currentValue)) {
                return 'https://' + this.currentValue;
            } else {
                return this.currentValue;
            }
        },
    },
    watch: {
        currentValue(newValue, oldValue) {
            if (!deepEqual(newValue, oldValue)) {
                this.$emit('update:modelValue', { ...this.localValue, ['stringValue']: newValue });
            }
        },
        value: {
            handler: function (newValue, oldValue) {
                if (!deepEqual(newValue, oldValue)) {
                    this.localValue = newValue;
                    this.currentValue = newValue.stringValue;
                }
            },
            deep: true,
        },
    },

    created() {
        if (!this.localValue) {
            this.localValue = JSON.parse(JSON.stringify(this.templateData));
            this.currentValue = this.prop.defaultValue;
        } else {
            this.currentValue = this.value.stringValue;
        }
    },
};
</script>
